<template>
  <div>
    <h4>Unformat Hex</h4>
    <p>Removes white spaces.</p>
    <textarea v-model="val"></textarea>
    <p class="result">{{result}}</p>
    <button @click="unformatHex">Go</button>
  </div>
</template>
<script>
  export default {
    data(){
      return{
        val: "",
        result: "",
      }
    },
    methods: {
      unformatHex(){
        let words = this.val.split(' ');
        this.result = words.join('');
      }
    }
  }
</script>
